// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiePolicyScreen_container__ti_hq"};